import axiosInstance from "../axios/axiosInstance";
import { buildApiUrl } from "../../config/api";

const API = buildApiUrl("/usersApp/permissions/");

export const userRolePermissionService = {
  async getAll() {
    return axiosInstance.get(API);
  },
};
